import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { enumIdentifierQualifier } from '@data-layer/enums/common';
import { enumEntityDataSource } from '@data-layer/enums/isf';
import { EntityModel } from '@data-layer/models/entities';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { CompanyModel } from '@data-layer/models/companies';
import { CompaniesService } from '@services/companies.service';

@Component({
  selector: 'app-entity-unify-card',
  templateUrl: './entity-unify-card.component.html',
  styleUrls: ['./entity-unify-card.component.scss'],
})
export class EntityUnifyCardComponent implements OnInit {
  @Input() public entity: EntityModel;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public code: enumEntityModelCode = null;
  @Input() public isCreating: boolean = false;
  @Input() public selectedValueControl: UntypedFormControl = new UntypedFormControl();
  @Input() public labelOverride: string;
  @Input() public isDesktop: boolean = false;

  public label: string;
  public dataSourceControl: AbstractControl;
  public enumEntityDataSource: typeof enumEntityDataSource = enumEntityDataSource;
  public isShowIdentifierBlock: boolean = true;
  public company: CompanyModel;

  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;

  constructor(private router: Router, private companiesService: CompaniesService) {}

  public ngOnInit(): void {
    this.isShowIdentifierBlock = !this.checkShowIdentifierBlock();

    this.company = this.companiesService.getCompany();

    this.label = this.labelOverride
      ? this.labelOverride
      : `INFO.${this.code.toLocaleUpperCase()}.USE_${this.entity.entityCode.toLocaleUpperCase()}`;
    this.dataSourceControl = new UntypedFormControl();
  }

  public onEditUP() {
    const returnUrl = this.router.url;
    this.router.navigate(['./companies', 'account-settings', 'company-view', this.company?.id], { queryParams: { returnUrl } });
  }

  private checkShowIdentifierBlock(): boolean {
    const isHideV =
      [this.enumEntityModelCode.SHIP_TO, this.enumEntityModelCode.MANUFACTURER, this.enumEntityModelCode.STAFFING_LOCATION].indexOf(
        this.code,
      ) !== -1;

    return (
      (this.entity.entityIdentifierQualifier === enumIdentifierQualifier.EIN ||
        this.entity.entityIdentifierQualifier === enumIdentifierQualifier.SSN) &&
      isHideV
    );
  }
}
